<template>
  <navbar position="fixed" type="primary" :transparent="transparent" menu-classes="ml-auto">
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img src="aiImg/AI Integration Vector Logo CMYK.png" class="creative-ai-logo"/>
      </router-link>
<!--      <el-popover ref="popover1" popper-class="popover" placement="bottom" width="200" trigger="hover">-->
<!--        <div class="popover-body">-->
<!--          AI Integration-->
<!--        </div>-->
<!--      </el-popover>-->
    </template>
    <template slot="navbar-menu">

   <!--   <drop-down tag="li" title="Services" icon="now-ui-icons design_app" class="nav-item">
     <nav-link to="/services">
          <i class="now-ui-icons loader_gear"></i> Software Engineering
        </nav-link>
        <nav-link to="/services">
          <i class="now-ui-icons loader_gear"></i> Cloud Architecture
        </nav-link>
        <nav-link to="/services">
          <i class="now-ui-icons loader_gear"></i> Data Analysis
        </nav-link>
        <nav-link to="/services">
          <i class="now-ui-icons loader_gear"></i> DevOps
        </nav-link>
        <nav-link to="/services">
          <i class="now-ui-icons loader_gear"></i> Prototyping
        </nav-link>
      </drop-down>
     //-->


    <li class="nav-item">
          <a class="nav-link" href="#/services">
            <i class="now-ui-icons design_app"></i>
            <p>Services</p>
          </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#/aboutus">
        <i class="now-ui-icons education_atom"></i>
        <p>About Us</p>
      </a>
    </li>
    <li class="nav-item">
          <a
            class="nav-link"
            href="#/careers"
          >
            <i class="now-ui-icons business_briefcase-24"></i>
            <p>Careers</p>
          </a>
        </li>
     <li class="nav-item">
           <a
             class="nav-link"
             href="#/contact"
           >
             <i class="now-ui-icons ui-1_email-85"></i>
             <p>Contact Us</p>
           </a>
         </li>





    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
